/* Product page: move the "In stock, ready to ship" line into the price row, between the price and the
   quantity buttons. When the row is too narrow, CSS drops it onto its own line under the price.
   The theme keeps updating the same element on variant changes, so moving it is safe.
   If this script doesn't run, the line simply stays as its own block under the price.
   Styles: assets/cart-drawer-v2.css ("Product page: stock line"). Loaded from snippets/gift-upsell-modal.liquid. */
(() => {
  const move = () => document.querySelectorAll('.product-block--price-qty').forEach(pq => {
    if (pq.querySelector('.sg-stock-inline')) return;
    const meta = pq.closest('.product-single__meta') || pq.parentElement;
    const inv = meta && meta.querySelector('.product-block--sales-point [data-product-inventory]');
    if (!inv) return;
    const blk = inv.closest('.product-block'), list = inv.closest('.sales-points');
    const qty = pq.querySelector('.product-qty-wrap');
    if (!blk || !list) return;
    list.classList.add('sg-stock-inline');
    pq.classList.add('has-stock');
    qty ? pq.insertBefore(list, qty) : pq.appendChild(list);
    blk.classList.add('is-emptied');
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', move) : move();
  // Quick-view modals render the product form later.
  document.addEventListener('quickshop:opened', move);
})();
